import { useEffect, useRef, useState } from "react";
import { getLogin } from "../services/authService";
import paths from "../pages/paths";
import { NotificationManager } from "react-notifications";
import useNavigation from "./useNavigation";

export const useLoginPageHook = () => {
  const [formState, setFormState] = useState({ email: "", password: "", rememberMe: true });
  const { redirectTo } = useNavigation();
  const emailInputRef = useRef(null);

  useEffect(() => {
    emailInputRef.current.focus();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password, rememberMe } = formState;
    if (email && password) {
      setFormState({ email: "", password: "", rememberMe });
      try {
        await getLogin(email, password, rememberMe);
        redirectTo(paths.index);
      } catch (error) {
        NotificationManager.error("Не прокатило, не фортануло", "", 3000);
      }
    }
  };

  return {
    formState,
    handleInputChange,
    handleSubmit,
    emailInputRef,
  };
};
